import cryptoJS from "@/utils/crypto-js";
import base64 from "@/utils/base64";
import storage from "@/utils/storage";
import api from '@/api'
import wxWork from '@/api/wxWork'
import { getQuery } from '@/utils/utils'
import device from '@/utils/device'
import utils from '@/utils/utils'
import roleEnum from '@/utils/enums/roleEnum'
import { getNameByValue } from '@/utils/enums/roleEnum'
import router, { resetRouter } from "@/router";

const APP_ID = '1022'
const CODE = 'code'
const USER_ID = 'userId'
const ROLE = 'role'
const USER_INFO = 'userInfo'
const PROCESS_ID = 'processId'
const SID = 'sid'
const TOKEN = 'token'
const PWD_STATUS = 'pwd_status'
const TASK_ID = 'taskId'
const UID = 'uid'
const ROUTES = 'routes'


const state = {
    userId: localStorage.getItem(USER_ID),
    role:storage.load(ROLE),
    userInfo: storage.load(USER_INFO),
    processId: localStorage.getItem(PROCESS_ID),
    sid: localStorage.getItem(SID),
    token: localStorage.getItem(TOKEN),
    pwdStatus: storage.load(PWD_STATUS),
    taskId: localStorage.getItem(TASK_ID),
    uid: localStorage.getItem(UID) || '{}',
    routes: null
}

const getters = {
    isLogin(state) {
        return !!state.token
    },
    userInfo(state) {
        return state.userInfo
    },
    hasAdminRole(state) {
        return state.role.includes(roleEnum.ADMIN.name)
    },
    hasRecruitRole(state) {
        return state.role.includes(roleEnum.RECRUIT.name)
    },
    hasRecruitManagerRole(state) {
        return state.role.includes(roleEnum.RECRUIT_MANAGER.name)
    },
    hasCandidateRole(state) {
        return state.role.includes(roleEnum.CANDIDATE.name)
    },  
}

const mutations = {
    SET_USER_ID(state, val) {
        if (!val) return
        state.userId = val
        localStorage.setItem(USER_ID, val)
    },
    SET_ROLE(state, val) {
        if (!val) return
        state.role = val
        storage.save(ROLE, val)
    },
    SET_USER_INFO(state, val) {
        if (!val) return
        state.userInfo = val
        storage.save(USER_INFO, val)
    },
    // 重置userId
    RESET_USER_ID(state) {
        state.userId = ''
        localStorage.removeItem(USER_ID)
    },
    SET_PROCESS_ID(state, val) {
        if (!val) return
        state.processId = val
        localStorage.setItem(PROCESS_ID, val)
    },
    // 重置processId
    RESET_PROCESS_ID(state) {
        state.processId = ''
        localStorage.removeItem(PROCESS_ID)
    },
    SET_SID(state, val) {
        if (!val) return
        state.sid = val
        localStorage.setItem(SID, val)
    },
    SET_TOKEN(state, val) {
        if (!val) return
        state.token = val
        localStorage.setItem(TOKEN, val)
    },
    // 重置sid
    RESET_SID(state) {
        state.sid = ''
        localStorage.removeItem(SID)
        location = location.href.replace(`${SID}=${getQuery(SID)}`, '')
    },
    // 重置token
    RESET_TOKEN(state) {
        state.token = ''
        localStorage.removeItem(TOKEN)
    },
    SET_TASK_ID(state, val) {
        if (!val) return
        state.taskId = val
        localStorage.setItem(TASK_ID, val)
    },
    // 重置taskId
    RESET_TASK_ID(state) {
        state.taskId = ''
        localStorage.removeItem(TASK_ID)
    },
    SET_UID(state, val) {
        if (!val) return
        let obj = JSON.parse(state.uid)
        obj[state.sid] = val
        localStorage.setItem(UID, JSON.stringify(obj))
    },
    SET_ROUTES(state, val) {
        state.routes=val
    },
    SET_PWD_STATUS(state, val) {
        state.pwdStatus = val
        val ? storage.save(PWD_STATUS, val) : localStorage.removeItem(PWD_STATUS)
    },
}

const actions = {
    getAuth({ commit }) {
        // router.push({
        //     name: 'Login'
        // })
        commit("form/SET_SHOW_LOGIN", true, { root: true });
    },
    getCode({ dispatch }, { diableGetAuth }) {
        return new Promise(async (resolve) => {
            let code = getQuery(CODE)
            if (code) {
                resolve(code)
                return
            }
            if (!diableGetAuth) {
                dispatch('getAuth')
            } else {
                resolve()
            }
        })
    },
    getUserId({ dispatch, commit }, { diableGetAuth }) {
        return new Promise(async (resolve, reject) => {
            let userId = getQuery(USER_ID) || localStorage.getItem(USER_ID);
            if (userId) {
                resolve(userId)
                return
            }
            // if (!device.isWxWork() || !device.isPCWxWork()) {
            //     reject(`${USER_ID}不存在`)
            //     return
            // }
            let code = await dispatch('getCode', { diableGetAuth })
            if (code) {
                let { data } = await wxWork.getUserId(code)
                userId = data.userId
                commit('SET_USER_ID', userId)
            }
            resolve(userId)
        })
    },
    getRole(){
        return Promise.resolve(storage.load(ROLE))
    },
    getUserInfo(){
        return Promise.resolve(storage.load(USER_INFO))
    },
    getProcessId() {
        return Promise.resolve(getQuery(PROCESS_ID) || localStorage.getItem(PROCESS_ID))
    },
    getSid({ dispatch, commit }, { userId, isRenew } = {}) {
        return Promise.resolve()
    },
    /**
     * 获取token
     * @param {Object}  
     * @param {Object} diableGetAuth:禁用获取授权 
     * @returns 
     */
    getToken() {
        return Promise.resolve(localStorage.getItem(TOKEN))
    },
    logout({ dispatch, commit }, { diableGetAuth } = {}) {
        commit('RESET_TOKEN')
        commit('RESET_USER_ID')
        commit('SET_PWD_STATUS', '')
        resetRouter()
        !diableGetAuth && dispatch('getAuth')
    },
    getTaskId() {
        return Promise.resolve(getQuery(TASK_ID) || localStorage.getItem(TASK_ID))
    },
    getUid({ dispatch }) {
        return new Promise(async resolve => {
            let uid = getQuery(UID);
            if (uid) {
                resolve(uid)
                return
            }
            let sid = await dispatch('getSid')
            resolve((JSON.parse(localStorage.getItem(UID)) || {})[sid])
        })
    },
    getPasswordStatus() {
        return Promise.resolve(storage.load(PWD_STATUS))
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}